<template>
    <div>not found</div>
</template>

<script>
export default {
    
}
</script>

<style scoped>

</style>